(() => {
  const dialog = document.getElementById('SacredShippingConfirmation');
  const config = document.getElementById('SacredShippingConfig');
  const attributeName = 'sacred_shipping_notice';
  let busy = false;
  let resuming = false;
  let pending = null;
  const stop = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  const termsFor = (form) => Array.from(document.querySelectorAll('[data-sacred-terms]')).find((input) => input.form === form);
  const saveAndResume = async (checkout) => {
    if (busy || !checkout.checkbox.checked || !checkout.form.isConnected) return;
    busy = true;
    checkout.form.setAttribute('aria-busy', 'true');
    const saveError = document.getElementById(`${checkout.checkbox.id}-shipping-error`);
    if (saveError) saveError.hidden = true;
    try {
      if (!config) throw new Error('Missing shipping configuration');
      const message = config.dataset.message || '';
      const response = await fetch(config.dataset.updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { [attributeName]: message } }),
        signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Could not save shipping notice');
      const cart = await response.json();
      if ((cart.attributes?.[attributeName] || '') !== message) throw new Error('Shipping notice was not saved');
      if (!checkout.checkbox.checked || termsFor(checkout.form) !== checkout.checkbox || !checkout.form.isConnected) return;
      document.querySelectorAll('[data-sacred-shipping-attribute]').forEach((input) => { input.value = message; });
      if (window.booster?.cart) window.booster.cart.attributes = cart.attributes;
      resuming = true;
      if (checkout.submission) {
        checkout.form.requestSubmit(checkout.element || undefined);
      } else if (checkout.element?.isConnected) {
        checkout.element.click();
      }
    } catch {
      if (saveError) saveError.hidden = false;
    } finally {
      resuming = false;
      busy = false;
      checkout.form.removeAttribute('aria-busy');
    }
  };
  const gate = (event, element, form, submission = false) => {
    const checkbox = form && termsFor(form);
    if (!checkbox) {
      stop(event);
      window.location.assign(window.routes.cart_url);
      return;
    }
    const error = document.getElementById(`${checkbox.id}-error`);
    if (!checkbox.checked) {
      stop(event);
      if (error) error.hidden = false;
      checkbox.setAttribute('aria-invalid', 'true');
      checkbox.focus();
      return;
    }
    if (resuming) return;
    stop(event);
    if (busy) return;
    const checkout = { element, form, submission, checkbox };
    if (dialog) {
      pending = checkout;
      if (!dialog.open) dialog.showModal();
    } else {
      saveAndResume(checkout);
    }
  };
  document.addEventListener('click', (event) => {
    const element = event.target.closest('button[name="checkout"], input[name="checkout"], [name="goto_pp"], [name="goto_gc"], a[href]');
    if (!element) return;
    if (element.tagName === 'A' && !/\/checkout(?:\/|\?|$)/.test(new URL(element.href).pathname + new URL(element.href).search)) return;
    const form = element.form || document.getElementById('cart') || document.getElementById('CartDrawer-Form');
    gate(event, element, form);
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form', 'cart-notification-form'].includes(form.id)) return;
    if (event.submitter && !['checkout', 'goto_pp', 'goto_gc'].includes(event.submitter.name)) return;
    gate(event, event.submitter, form, true);
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-sacred-terms]')) return;
    const checkbox = event.target;
    const error = document.getElementById(`${checkbox.id}-error`);
    if (error) error.hidden = true;
    checkbox.removeAttribute('aria-invalid');
    const saveError = document.getElementById(`${checkbox.id}-shipping-error`);
    if (saveError) saveError.hidden = true;
  });
  if (!dialog) return;
  dialog.querySelector('[data-sacred-shipping-cancel]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { pending = null; });
  dialog.querySelector('[data-sacred-shipping-continue]').addEventListener('click', () => {
    const checkout = pending;
    dialog.close();
    if (!checkout || !checkout.checkbox.checked || !checkout.form.isConnected) return;
    saveAndResume(checkout);
  });
})();
